import React, { useState } from 'react';
import { Box, Tabs, Tab, } from '@mui/material';
import { useSelector } from 'react-redux';
import CourseCallScheduleAdmin from './CourseCallScheduleAdmin';
import WebsiteLead from './WebsiteLead';
import AdminUniversityCounseling from './University/UniversityCounseling';
import { hasModuleAccess } from '../utils/helperFunction';
const AdminLeads = () => {
  const userAuth = useSelector(state => state?.auth)
  const paginationSlice = useSelector(state => state.pagination)
  const [tabIndex, setTabIndex] = useState(paginationSlice?.activeTab || 0);
  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: '100%', }}>
      <Tabs sx={{ width: '100%', px: 2, position: 'sticky', top: '70px', background: '#fff', borderBottom: '1px solid #ccc', zIndex: 9, }}
        value={tabIndex}
        onChange={handleChange}
        aria-label="admin review tabs"
        textColor="primary"
        indicatorColor="primary"
      >
        {hasModuleAccess(userAuth?.user?.roles, ["web.leads.web_leads"]) && <Tab label="Web leads" />}
        {hasModuleAccess(userAuth?.user?.roles, ["web.leads.counseling"]) && <Tab label="Counseling" />}
        {hasModuleAccess(userAuth?.user?.roles, ["web.leads.schedule_call"]) && <Tab label="Schedule Call" />}
      </Tabs>

      <Box sx={{ p: 0 }}>
        {tabIndex === 0 && hasModuleAccess(userAuth?.user?.roles, ["web.leads.web_leads"]) && <><WebsiteLead activeTab={tabIndex} module="web.leads" type={"web-leads"} /></>}
        {tabIndex === 1 && hasModuleAccess(userAuth?.user?.roles, ["web.leads.counseling"]) && <><AdminUniversityCounseling activeTab={tabIndex} module="web.leads" type={"universit-counseling"} /></>}
        {tabIndex === 2 && hasModuleAccess(userAuth?.user?.roles, ["web.leads.schedule_call"]) && <><CourseCallScheduleAdmin activeTab={tabIndex} module="web.leads" type={"schedule-call"} /></>}
      </Box>
    </Box>
  );
};
export default AdminLeads;
